module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABHCAMAAACNrMETAAAASFBMVEUAAAD8yAAAAAAeGADUqADntwD5xgApIABSQQAjGwALCQDEmwDfsQDInwAOCwDywADgsgDhsgBcSQA+MQAWEQDSpwB5YAA1KgAgNatHAAAAAXRSTlMAQObYZgAAAKJJREFUWMPt1UsOgkAQRVFtRUVtUEDd/07V0Z34Ibk9gFBvASepSqXeqlDWRRJMMMEEE8yimGrYVwWYtk44YqgLjmBw7IrPOILBEQyOY3Akw579FV9xBIMzkmlv28/JA85/pk8/0o9m7psvqZuUOv8ocpMOO82cjm/FMCiGQTEMimFQDINiGBTLZBTBcHWqp1BUTz26lzKV8g0mmGCCCWYWzBNCRRdvQKaW8QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/toRightIcon.png
// module id = lpkL
// module chunks = 2